import { render } from "./Pagination.vue?vue&type=template&id=d3995390"
import script from "./Pagination.vue?vue&type=script&lang=js"
export * from "./Pagination.vue?vue&type=script&lang=js"

const cssModules = script.__cssModules = {}
import style0 from "./Pagination.vue?vue&type=style&index=0&id=d3995390&module=true&lang=css"
cssModules["$style"] = style0
script.render = render

export default script